package music.jammers.client.shared.auth.presentation.ui

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowColumn
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.material3.CircularProgressIndicator
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.paint
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.unit.dp
import limasoul.client.shared.generated.resources.Res
import limasoul.client.shared.generated.resources.base_background
import limasoul.client.shared.generated.resources.google_icon
import limasoul.client.shared.generated.resources.login_cannot_find_account
import limasoul.client.shared.generated.resources.login_wanna_join
import limasoul.client.shared.generated.resources.login_welcome_title
import limasoul.client.shared.generated.resources.logo
import music.jammers.client.shared.auth.di.LoginComponent
import music.jammers.client.shared.auth.presentation.viewmodel.LoginState
import music.jammers.client.shared.auth.presentation.viewmodel.LoginViewModel
import music.jammers.client.shared.component.ErrorDialog
import music.jammers.client.shared.signin.GoogleButton
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

@Composable
fun LoginScreen() {
    val viewModel = remember { LoginComponent.viewModel }
    val loginState = viewModel.state

    Scaffold { _ ->
        Box(
            modifier = Modifier
                .fillMaxSize()
                .paint(
                    painterResource(Res.drawable.base_background),
                    contentScale = ContentScale.Crop,
                )
        ) {
            when (val state = loginState.value) {
                LoginState.Content         -> LoginContent(viewModel)

                LoginState.GoogleLogin     -> LoginProgress()

                LoginState.OnCreateAccount -> ErrorDialog(stringResource(Res.string.login_cannot_find_account)) {
                    viewModel.onDialogClosed()
                }

                is LoginState.Error        -> ErrorDialog(state.message) {
                    viewModel.onDialogClosed()
                }
            }
        }
    }
}

@OptIn(ExperimentalLayoutApi::class)
@Composable
private fun LoginContent(
    viewModel: LoginViewModel,
) {
    FlowColumn(
        verticalArrangement = Arrangement.SpaceAround,
        modifier = Modifier
            .fillMaxSize()
            .padding(vertical = 64.dp),
    ) {
        Column(
            modifier = Modifier.fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Text(
                text = stringResource(Res.string.login_welcome_title).uppercase(),
                style = MaterialTheme.typography.headlineSmall,
            )

            Image(
                painter = painterResource(Res.drawable.logo),
                contentDescription = "Welcome logo",
                modifier = Modifier.padding(end = 16.dp),
            )
        }

        Column(
            modifier = Modifier
                .align(Alignment.CenterHorizontally)
        ) {
            Text(
                text = stringResource(Res.string.login_wanna_join).uppercase(),
                style = MaterialTheme.typography.headlineSmall
            )

            Spacer(modifier = Modifier.size(20.dp))

            GoogleButton(
                onResponse = { response ->
                    viewModel.onGoogleAuthResponse(response)
                },
                iconDrawable = Res.drawable.google_icon,
                modifier = Modifier.align(Alignment.CenterHorizontally)
            )
        }
    }
}

@Composable
private fun LoginProgress() {
    Column(
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally,
        modifier = Modifier.fillMaxSize(),
    ) {
        CircularProgressIndicator(
            color = MaterialTheme.colorScheme.primary
        )
    }
}
